import TableSelect from '@utils/table-select/index'
import Table from '@utils/table'
import Operation from '@utils/common/operation'
import { status, fieldType } from './index'
import OptionsSelect from '@/components/select/options-select/options-select.vue'
import Search from '@utils/search'

const search = new Search('barcode.rule')
  .placeholder('dialogPlaceholder')

function fieldTypeHandle(vm: any, value: string) {
  vm.row.leng = !!value && vm.row.codeFactor === 'B' ? value.length : vm.row.leng
}

function remove(this: any, row: any, index: number) {
  const value = [...this.value]
  value.splice(index, 1)
  this.$emit('input', value)
}

function filter(selection: any[], data: any[]) {
  const set = new Set(data.map(i => i.codeFactor))
  return selection.filter(i => !set.has(i.codingId)).map(item => {
    return { ...item, partRemarks: '', fieldType: '', fieldValue: '', simulation: '', codeFactor: item.codingId, leng: item.codingId === 'D' ? 4 : 0, isLotNoPart: 'N', status: 1 }
  })
}

const operation = new Operation()
  .add('release').label('common.remove').handle(remove)

const table = new Table('barcode.rule', true)
  .type('index')
  .sortable(false)
  .add('partRemarks').editor().width(150)
  .add('codeFactor')
  .add('instruction')
  .add('fieldType').editor({ component: OptionsSelect, on: { input: fieldTypeHandle }}).bind('_options', fieldType).width(180)
  .add('fieldValue').editor().width(150)
  .add('leng').editor('el-input-number').attrs({ controlsPosition: 'right', min: 1 }).width(150)
  .add('isLotNoPart').editor('el-switch').attrs({ 'active-value': 'Y', 'inactive-value': 'N' }).width(150)
  .add('simulation').editor().width(150)
  .lib('remarks').editor().width(150)
  .add('status').op(status)

const dialogTable = new Table('barcode.rule')
  .add('codingId')
  .add('parameter')
  .add('instruction')
  .lib('remarks')
  .add('status').op(status)

export default new TableSelect('barcode.rule')
  .type('page')
  .url('/srmBarcodeFactor/getSrmBarcodeFactorListByParams', process.env.VUE_APP_BASE_DATA_API)
  .params({ status: 1 })
  .title('formTitle.barcodeInfo')
  .search(search)
  .dialogTitle('dialogTitle')
  .table(table)
  .dialogTable(dialogTable)
  .operation(operation)
  .filter(filter)
